import { render } from "./Memorisation.vue?vue&type=template&id=695bd401&lang=pug"
import script from "./Memorisation.vue?vue&type=script&lang=ts"
export * from "./Memorisation.vue?vue&type=script&lang=ts"

import "./Memorisation.vue?vue&type=style&index=0&id=695bd401&lang=scss"
script.render = render

export default script